import React from 'react';
import styles from './styles.mod.scss';
import ScreenReaderText from 'components/ScreenReaderText';
import classnames from 'classnames';

const Switch = ({ roundUpEnabled, handleSwitchToggle }) => {
  return (
    <>
      <label
        htmlFor="toggleSwitch"
        className={styles.label}
        onClick={() => handleSwitchToggle(roundUpEnabled)}
      >
        <ScreenReaderText>toggle switch</ScreenReaderText>
      </label>
      <input
        name="toggleSwitch"
        type="checkbox"
        id="toggleSwitch"
        onChange={() => {}}
        checked={roundUpEnabled}
        className={classnames(styles.checkBox, styles.hidden)}
        aria-label="toggle switch"
      />
    </>
  );
};

export default Switch;
